export const WORDS = ['bestman', 'officiant', 'groomsman'];
